import React from "react";

/**
 * EmptyState premium — SVG illustration custom (navy + gold),
 * titolo serif, descrizione muted, CTA opzionale.
 *
 * Uso:
 *   <EmptyState
 *     variant="documents"        // documents | clients | search | pipeline | chat | knowledge | calendar | generic
 *     title="Nessun documento"
 *     description="Carica il primo file per iniziare."
 *     action={<button>...</button>}
 *   />
 */

const ILLUSTRATIONS = {
  documents: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="es-doc-g1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F5EFE3"/>
          <stop offset="100%" stopColor="#E8DDC3"/>
        </linearGradient>
      </defs>
      {/* back doc */}
      <rect x="30" y="24" width="52" height="66" rx="3" fill="#FFFFFF" stroke="#0A192F" strokeWidth="1.4" opacity="0.35"/>
      {/* front doc */}
      <rect x="38" y="32" width="52" height="66" rx="3" fill="url(#es-doc-g1)" stroke="#0A192F" strokeWidth="1.6"/>
      <line x1="46" y1="46" x2="80" y2="46" stroke="#0A192F" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="46" y1="54" x2="80" y2="54" stroke="#0A192F" strokeWidth="1.4" strokeLinecap="round" opacity="0.6"/>
      <line x1="46" y1="62" x2="70" y2="62" stroke="#0A192F" strokeWidth="1.4" strokeLinecap="round" opacity="0.4"/>
      {/* gold seal */}
      <circle cx="78" cy="80" r="8" fill="#B7955B"/>
      <circle cx="78" cy="80" r="5.5" fill="none" stroke="#FFFFFF" strokeWidth="1.2"/>
      <path d="M74.5 80l2.5 2.5 4-4.5" stroke="#FFFFFF" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  ),

  clients: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* card back */}
      <rect x="18" y="34" width="84" height="52" rx="4" fill="#FFFFFF" stroke="#0A192F" strokeWidth="1.4" opacity="0.35"/>
      {/* card front */}
      <rect x="24" y="42" width="84" height="52" rx="4" fill="#F5EFE3" stroke="#0A192F" strokeWidth="1.6"/>
      {/* avatar circle */}
      <circle cx="42" cy="66" r="10" fill="#0A192F"/>
      <circle cx="42" cy="63" r="3.5" fill="#B7955B"/>
      <path d="M34 74c2-5 6-6 8-6s6 1 8 6" stroke="#B7955B" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      {/* lines */}
      <line x1="58" y1="58" x2="96" y2="58" stroke="#0A192F" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="58" y1="66" x2="88" y2="66" stroke="#0A192F" strokeWidth="1.4" strokeLinecap="round" opacity="0.6"/>
      <line x1="58" y1="74" x2="80" y2="74" stroke="#0A192F" strokeWidth="1.4" strokeLinecap="round" opacity="0.4"/>
      {/* gold star accent */}
      <path d="M92 26l1.8 3.7 4 0.6-2.9 2.8 0.7 4-3.6-1.9-3.6 1.9 0.7-4-2.9-2.8 4-0.6z" fill="#B7955B"/>
    </svg>
  ),

  search: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="52" cy="52" r="26" fill="#F5EFE3" stroke="#0A192F" strokeWidth="1.8"/>
      <circle cx="52" cy="52" r="18" fill="none" stroke="#0A192F" strokeWidth="1.2" opacity="0.35" strokeDasharray="2 3"/>
      <line x1="72" y1="72" x2="94" y2="94" stroke="#0A192F" strokeWidth="3" strokeLinecap="round"/>
      <line x1="72" y1="72" x2="94" y2="94" stroke="#B7955B" strokeWidth="1.4" strokeLinecap="round"/>
      {/* question mark inside */}
      <path d="M46 46c0-3 3-5 6-5s6 2 6 5c0 3-6 4-6 8" stroke="#0A192F" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      <circle cx="52" cy="63" r="1.6" fill="#B7955B"/>
    </svg>
  ),

  pipeline: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* 3 stacked cards */}
      <rect x="20" y="34" width="24" height="60" rx="3" fill="#FFFFFF" stroke="#0A192F" strokeWidth="1.4"/>
      <rect x="48" y="34" width="24" height="60" rx="3" fill="#F5EFE3" stroke="#0A192F" strokeWidth="1.4"/>
      <rect x="76" y="34" width="24" height="60" rx="3" fill="#FFFFFF" stroke="#0A192F" strokeWidth="1.4"/>
      {/* header dots */}
      <circle cx="32" cy="44" r="2.5" fill="#0A192F"/>
      <circle cx="60" cy="44" r="2.5" fill="#B7955B"/>
      <circle cx="88" cy="44" r="2.5" fill="#0A192F" opacity="0.4"/>
      {/* lines */}
      <line x1="24" y1="56" x2="40" y2="56" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="24" y1="64" x2="36" y2="64" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
      <line x1="52" y1="56" x2="68" y2="56" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="52" y1="64" x2="64" y2="64" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
      <line x1="80" y1="56" x2="96" y2="56" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      {/* arrows between */}
      <path d="M44 64l3 -3 -3 -3" stroke="#B7955B" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      <path d="M72 64l3 -3 -3 -3" stroke="#B7955B" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    </svg>
  ),

  chat: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* bubble left */}
      <path d="M18 34 h44 a4 4 0 0 1 4 4 v20 a4 4 0 0 1 -4 4 h-32 l-8 8 v-8 h-4 a4 4 0 0 1 -4 -4 v-20 a4 4 0 0 1 4 -4 z" fill="#F5EFE3" stroke="#0A192F" strokeWidth="1.6"/>
      <line x1="24" y1="44" x2="58" y2="44" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="24" y1="50" x2="50" y2="50" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
      {/* bubble right (navy) */}
      <path d="M56 60 h44 a4 4 0 0 1 4 4 v20 a4 4 0 0 1 -4 4 h-4 v8 l-8 -8 h-32 a4 4 0 0 1 -4 -4 v-20 a4 4 0 0 1 4 -4 z" fill="#0A192F" stroke="#0A192F" strokeWidth="1.6"/>
      <circle cx="72" cy="74" r="1.8" fill="#B7955B"/>
      <circle cx="80" cy="74" r="1.8" fill="#B7955B"/>
      <circle cx="88" cy="74" r="1.8" fill="#B7955B"/>
    </svg>
  ),

  knowledge: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* book left */}
      <path d="M20 30 v66 c0 -2 12 -6 40 -6 v-66 c-28 0 -40 4 -40 6z" fill="#F5EFE3" stroke="#0A192F" strokeWidth="1.6"/>
      {/* book right */}
      <path d="M100 30 v66 c0 -2 -12 -6 -40 -6 v-66 c28 0 40 4 40 6z" fill="#FFFFFF" stroke="#0A192F" strokeWidth="1.6"/>
      {/* center spine */}
      <line x1="60" y1="30" x2="60" y2="90" stroke="#0A192F" strokeWidth="1.6"/>
      {/* lines */}
      <line x1="28" y1="48" x2="52" y2="46" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="28" y1="56" x2="52" y2="54" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
      <line x1="68" y1="46" x2="92" y2="48" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="68" y1="54" x2="92" y2="56" stroke="#0A192F" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
      {/* gold bookmark */}
      <path d="M78 30 v18 l4 -3 4 3 v-18 z" fill="#B7955B"/>
    </svg>
  ),

  calendar: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="22" y="32" width="76" height="62" rx="4" fill="#FFFFFF" stroke="#0A192F" strokeWidth="1.6"/>
      <rect x="22" y="32" width="76" height="14" fill="#0A192F"/>
      {/* rings */}
      <line x1="38" y1="26" x2="38" y2="42" stroke="#0A192F" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="82" y1="26" x2="82" y2="42" stroke="#0A192F" strokeWidth="2.4" strokeLinecap="round"/>
      {/* days grid */}
      <circle cx="36" cy="60" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="50" cy="60" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="64" cy="60" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="78" cy="60" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="36" cy="72" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="50" cy="72" r="2.5" fill="#B7955B"/>
      <circle cx="64" cy="72" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="78" cy="72" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="36" cy="84" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="50" cy="84" r="2" fill="#0A192F" opacity="0.4"/>
      <circle cx="64" cy="84" r="2" fill="#0A192F" opacity="0.4"/>
    </svg>
  ),

  generic: (
    <svg viewBox="0 0 120 120" width="120" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="60" cy="60" r="38" fill="#F5EFE3" stroke="#0A192F" strokeWidth="1.6"/>
      <circle cx="60" cy="60" r="28" fill="none" stroke="#B7955B" strokeWidth="1.4" strokeDasharray="3 4"/>
      <path d="M52 60l6 6 12 -14" stroke="#0A192F" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  ),
};

export default function EmptyState({
  variant = "generic",
  title,
  description,
  action,
  className = "",
  compact = false,
}) {
  const illustration = ILLUSTRATIONS[variant] || ILLUSTRATIONS.generic;
  return (
    <div
      className={`animate-empty-in flex flex-col items-center justify-center text-center ${compact ? "py-8" : "py-16"} ${className}`}
      data-testid={`empty-state-${variant}`}
    >
      <div className="empty-illustration">{illustration}</div>
      {title && (
        <h3 className="font-serif text-xl sm:text-2xl font-light text-slate-800 mt-4 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
          {title}
        </h3>
      )}
      {description && (
        <p className="text-sm text-slate-500 mt-2 max-w-md leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
